module.exports = __webpack_public_path__ + "statics/img/465ff23.465ff23b.png";